import { useEffect, useState } from "react";
import { PostApiData } from "../api/general";
import { ROUTES } from "../constants/api";
import { EVENTS } from "../constants/events";
import { trackEvent } from "../services/eventTracker";
import { APIButtonType, GetMyCardResponse } from "../types/api/card";

export const useMyCardActions = (
  data: GetMyCardResponse,
  getMyCardData: () => Promise<void> | void,
  getFeatureFlags: () => Promise<void> | void,
  openErrorModal: (err: unknown) => void
) => {
  const [loadingButtonId, setLoadingButtonId] = useState<string | null>(null);

  // Keep the spinner until the lock state actually flips.
  useEffect(() => {
    setLoadingButtonId(null);
  }, [data.cardImageData.isLocked]);

  const lockUnlock = async (button: APIButtonType) => {
    const { isLocked } = data.cardImageData;
    const eventName = isLocked
      ? EVENTS.LOCK_CARD.UNLOCK_CARD_SUBMITTED
      : EVENTS.LOCK_CARD.LOCK_CARD_SUBMITTED;

    setLoadingButtonId(button.id);
    try {
      const url = isLocked ? ROUTES.CARD.UNLOCK_CARD : ROUTES.CARD.LOCK_CARD;
      await PostApiData(url, { cardid: data.cardId });
      trackEvent(eventName, { success: true });
      getMyCardData();
      getFeatureFlags();
    } catch (err: any) {
      setLoadingButtonId(null);
      openErrorModal(err);
      trackEvent(eventName, {
        success: false,
        failure_reason: err?.data?.errors?.[0]?.errorMessage ?? "An error has occurred.",
      });
    }
  };

  return { loadingButtonId, lockUnlock };
};